import Back from "@@/core/components/shared/Back/Back";
import Multiselect from "vue-multiselect";
import Ckeditor from "@@/core/components/shared/Ckeditor/Ckeditor";

import {
  BForm,
  BFormInput,
  BFormGroup,
  BFormTextarea,
  BFormCheckbox,
  BFormFile,
  BButton,
} from "bootstrap-vue";
export default {
  name: "PostCreateEdit",
  components: {
    Back,
    BForm,
    BFormInput,
    BFormGroup,
    BFormTextarea,
    BFormCheckbox,
    BFormFile,
    Multiselect,
    Ckeditor,
    BButton,
  },
  data() {
    return {
      postForm: {
        title: "",
        main_image: null,
        summary: "",
        post_category_id: null,
        body: "",
        meta_description: "",
        published_at: "",
        special: 0,
        status: "",
      },
      statusOption: [
        { value: "draft", label: "draft" },
        { value: "pending", label: "در انتظار تکمیل" },
        { value: "published", label: "انتشار یافته" },
        { value: "unpublished", label: "unpublished" },
      ],
      categoriesOption: [],
      mode: "create",
      disabled: false,
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.url = "admin/posts/" + this.$route.params.id;
      this.mode = "edit";
      this.getCategories(true);
    } else {
      this.url = "admin/posts";
      this.getCategories();
    }
  },
  methods: {
    async getCategories(getPost = false) {
      try {
        const response = await this.$axios.get("admin/posts/create");
        this.categoriesOption = response.data.data.postCategories;
        if (getPost) {
          const response = await this.$axios.get(this.url);
          this.postForm = response.data.data.post;
          this.postForm.post_category_id = this.categoriesOption.find(
            (item) => item.id == this.postForm.post_category_id
          );
          this.postForm.status = this.statusOption.find(
            (item) => item.value == this.postForm.status
          );
        }
      } catch (error) {
        this.$root.notify(error);
      }
    },
    back() {
      this.$refs.back.$el.click();
    },
    async submitHandler() {
      this.disabled = true;
      const formData = new FormData();
      for (const key in this.postForm) {
        if (key == "post_category_id") {
          formData.append(
            key,
            this.postForm[key] ? this.postForm[key].id : null
          );
        } else if (key == "status") {
          formData.append(
            key,
            this.postForm[key] ? this.postForm[key].value : null
          );
        } else if (key == "order") {
          continue;
        } else {
          formData.append(key, this.postForm[key]);
        }
      }
      formData.set("_method", this.mode === "create" ? "post" : "put");
      try {
        const response = await this.$axios.post(this.url, formData);
        this.$root.notify(response, "success");
        this.back();
      } catch (error) {
        this.$root.notify(error);
      }
      this.disabled = false;
    },
  },
};
